import { Store, User, Clock } from 'lucide-react';
import CashBalanceBadge from './CashBalanceBadge';

interface Props {
  data?: any | null;
}

const CashSessionInfoView: React.FC<Props> = ({ data }) => {
  const hasSession = !!data;

  const openingDateTime = data?.openedAt
    ? new Date(data.openedAt).toLocaleString('es-SV', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '--/--/---- --:--';

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      {/* HEADER */}
      <div className="flex items-center justify-between border-b border-stroke px-5 py-4 dark:border-strokedark">
        <div className="flex items-center gap-2">
          <Store size={16} className="text-primary" />
          <h3 className="text-sm font-medium text-black dark:text-white">
            Sesión de Caja
          </h3>
        </div>

        {/* STATUS BADGE */}
        <span
          className={`
          inline-flex items-center rounded px-2 py-0.5 text-xs font-medium
          ${
            hasSession
              ? 'bg-[#3CA745] text-white'
              : 'bg-[#F9C107] text-[#212B36]'
          }
        `}
        >
          {hasSession ? 'Activa' : 'Sin sesión'}
        </span>
      </div>

      {/* BODY */}
      <div className="space-y-4 p-5">
        {/* GRID INFO */}

        <div className="grid grid-cols-1 gap-3">
          <InfoItem
            icon={<Store size={16} />}
            label="Terminal"
            value={data?.registerName ?? '—'}
          />

          <InfoItem
            icon={<User size={16} />}
            label="Usuario"
            value={data?.openedByName ?? '—'}
          />

          <InfoItem
            icon={<Clock size={16} />}
            label="Apertura"
            value={openingDateTime}
          />
        </div>

        {/* BALANCE */}
        <div className="pt-2">
          <CashBalanceBadge balance={data?.currentBalance ?? 0} />
        </div>
      </div>
    </div>
  );
};

export default CashSessionInfoView;

/**
 * 🔹 ITEM MODERNO (LIMPIO)
 */
const InfoItem = ({ icon, label, value }: any) => {
  return (
    <div className="flex items-center gap-3 py-2">

      {/* ICON */}
      <div className="text-primary/80">
        {icon}
      </div>

      {/* TEXT */}
      <div className="min-w-0">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {label}
        </p>

        <p className="truncate text-sm font-medium text-black dark:text-white">
          {value}
        </p>
      </div>

    </div>
  );
};
